import React, { useState } from "react";
import moment from "moment";

const FuelRatesValidator = (props) => {
  const record = props.data.record;
  const [state, setState] = useState({
    error: null,
    errorMessage: null
  }); 

  let error = false;
  let errorMessage = "";

  if (!record.airportCode) {
    error = true;
    errorMessage = "Please select a valid Airport";
  } else if (!record.supplierCode) {
    error = true;
    errorMessage = "Please select a valid Supplier";
  } else if (!moment(record.validFrom).isValid()) {
    error = true;
    errorMessage = "Please enter a valid 'Valid From' date";
  } else if (!moment(record.validTo).isValid()) {
    error = true;
    errorMessage = "Please enter a valid 'Valid To' date";
  } else if (moment(record.validTo).isBefore(record.validFrom)) {
    error = true;
    errorMessage = "The 'Valid To' date cannot be before the 'Valid From' date";
  // } else if (!record.plattsPrice || record.plattsPrice <= 0) {
  //   error = true;
  //   errorMessage = "The platts price must be greater than zero";
  } else if (!record.currencyCode) {
    error = true;
    errorMessage = "Please select a valid currency";
  } else if (!record.priceUom) {
    error = true;
    errorMessage = "Please select a valid unit of measure";
  } else if (record.dollarPlattsPrice > 1000) {
    error = true;
    errorMessage = "The platts price converted to USDC is excessive";
  }   

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {        
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <div style={{display:"none"}}>
      {state.errorMessage}
    </div>
  );
}

export default FuelRatesValidator;
